<template>
    <div class="has-orderManagement-component">
      <div class="column is-8 is-offset-2">
        <div class="columns">
          <div class="column is-full">
            <p class="is-size-3 has-text-centered has-text-grey-dark dm-sans">
              Gostaria de ter o módulo Gestão de Pedidos para impulsionar suas vendas pelo Pedbot?
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <div class="buttons is-flex is-justify-content-center is-full">
              <button
                  class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                  @click.prevent="selectOrderManagement()"
              >
                Sim
              </button>
              <button
                  class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                  @click.prevent="selectNoOrderManagement()"
              >
                Não
              </button>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <p class="is-size-4 has-text-centered has-text-grey-dark dm-sans mt-6">
              * Esse serviço é opcional e tem custo de R$ {{ formatPrice(orderManagement.price) }} por mês
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
  
    import orderManagementApi from '@/apis/orderManagement'
  
    export default {
  
        name: 'order-management',
  
        data() {
            return {
                orderManagement: {}
            }
        },
  
        props: {
            formData: {
                required: true,
                type: Object
            }
        },
  
        watch: {
            'formData.plan': {
                handler() {
                    this.getOrderManagement()
                },
                deep: true
            }
        },
  
        methods: {
            cleanData() {
                this.formData.orderManagement.data = {}
            },
            formatPrice(value) {
                return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
                    .replace('R$', '').trim();
            },
            selectOrderManagement() {
                this.formData.orderManagement.showStep = true
                this.formData.orderManagement.data = this.orderManagement
                this.$emit('nextTab')
            },
            selectNoOrderManagement() {
                this.formData.orderManagement.showStep = false
                this.formData.orderManagement.data = {}
                this.$emit('nextTab')
            },
            async getOrderManagement() {
                if (this.formData.plan.data.id) {
                    this.orderManagement = await orderManagementApi.get({
                        plan_id: this.formData.plan.data.id
                    })
                }
            }
        },
    
        mounted() {
            this.getOrderManagement()
        }
  
  }
  
</script>
  